import BaseApi from './BaseApi'

class ContactNumberTypesApi extends BaseApi {
  get contactNumberTypesUrl () {
    return 'contactNumberTypes'
  }

  fetchingContactNumberTypes () {
    return this.getJson(this.contactNumberTypesUrl)
  }
}

export default ContactNumberTypesApi
